import { useEffect, useState } from 'react'
import cnames from 'classnames'
import { Form, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap'
import FontAwesomeIcon from 'Shared/FontAwesomeIcon/FontAwesomeIcon'

const options = [
  { label: 'Under Maintenance', value: 'under_maintenance', icon: 'screwdriver-wrench' },
  { label: 'Electrical Issue', value: 'electrical', icon: 'plug-circle-xmark' },
  { label: 'Plumbing Issue', value: 'plumbing', icon: 'pipe-valve' },
  { label: 'Flooding / Weather Damage', value: 'weather', icon: 'cloud-bolt-sun' },
  { label: 'Reserved for Staff / Employee Site', value: 'staff', icon: 'clipboard-user' },
  { label: 'Renovation or Construction', value: 'construction', icon: 'excavator' },
  { label: 'Pest Control', value: 'pest', icon: 'bug-slash' },
  { label: 'Septic Issue', value: 'septic', icon: 'pump' },
  { label: 'Event Hold / Group Reservation Prep', value: 'event', icon: 'party-horn' },
  { label: 'Other', value: 'other', icon: 'circle-question', adminOnly: true },
]

const CalendarBlockForm = ({ disabled, isEngineAdmin, onChange, onDropdown, value }) => {
  const [selected, setSelected] = useState('')
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const selectedOption = options.find(opt => opt.value === selected)

  const dropdownItemClasses = (active = false) =>
    cnames('d-flex align-items-center border-bottom border-secondary-subtle py-2', { active })

  useEffect(() => {
    if (value !== '') {
      const item = options.find(opt => opt.label === value)
      setSelected(item ? item.value : 'other')
    } else
      setSelected('')
  }, [value])

  const toggleDropdown = () => {
    setDropdownOpen(prevState => !prevState)
    onDropdown(!dropdownOpen)
  }

  const toggleOption = (value, label) => {
    setSelected(value)
    if (onChange) onChange({ value, label })
    setDropdownOpen(false)
  }

  return (
    <Form>
      <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
        <DropdownToggle disabled={disabled} caret color="#fff"
                        className="d-flex border-secondary align-items-center justify-content-between w-100 py-2">
          {selectedOption ? (
            <div className="d-flex align-items-center">
              <div className="me-2 d-flex align-items-center justify-content-center" style={{ width: '24px' }}>
                <FontAwesomeIcon icon={selectedOption.icon} size="lg" />
              </div>
              {selectedOption.label}
            </div>
          ) : (
            <span className="text-muted">Reason for blocking the site</span>
          )}
        </DropdownToggle>
        <DropdownMenu className="w-100 border-0">
          {options.filter(opt => !opt.adminOnly).map(opt => (
            <DropdownItem className={dropdownItemClasses(selected === opt.value)} key={opt.value}
                          onClick={() => { toggleOption(opt.value, opt.label); toggleDropdown() }}>
                <div className="me-2 d-flex align-items-center justify-content-center" style={{ width: '24px' }}>
                  <FontAwesomeIcon icon={opt.icon} size="lg" />
                </div>
                {opt.label}
            </DropdownItem>
          ))}
          {isEngineAdmin && (
            <DropdownItem className={dropdownItemClasses(selected === 'other')} key="other"
                          onClick={() => { toggleOption('other', 'Other'); toggleDropdown() }}>
                <div className="me-2 d-flex align-items-center justify-content-center" style={{ width: '24px' }}>
                  <FontAwesomeIcon icon="circle-question" size="lg" />
                </div>
                Other
            </DropdownItem>
          )}
        </DropdownMenu>
      </Dropdown>
    </Form>
  )
}

export default CalendarBlockForm
